import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { SheetSlotComponentBase } from 'src/app/services/sheets-renderer.service';
import { SoapAction } from 'src/app/types/sheet-action-aggregate-graph.types';
import { TickValueComponent } from '../../tick-value/tick-value.component';

@Component({
    selector: 'app-soap-slot',
    templateUrl: './soap-slot.component.html',
    styleUrl: './soap-slot.component.scss',
    imports: [TickValueComponent],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class SoapSlotComponent implements SheetSlotComponentBase {

	@Input() action!: SoapAction;
	value = null;

	constructor() {
	}
}